module.exports = __webpack_public_path__ + "static/media/switch.02965bfc.svg";